/*
  Lista zyczen - podstrona.

  Buduje strone z danych z `window.wishlist` (magazyn w przegladarce) i wzorcow
  markupu wypisanych przez sekcje, wiec zaden napis nie jest zaszyty tutaj.
  Kafle to karty motywu dociagane z serwera, razem z ich wlasnymi akcjami:
  serduszko w lewym gornym narozniku zdejmuje wzor z listy, okragly przycisk
  w prawym dodaje do koszyka. Obie akcje znacza na tej stronie to samo, co na
  kazdym listingu sklepu - tutaj tylko przejmujemy wysylke formularza koszyka,
  zeby klient nie wypadl z listy po jednym zakupie.

  Wszystkie komunikaty ida przez wspolny pasek (`window.wishlistBar`), ten sam,
  ktory potwierdza odkladanie wzorow na listingach.
*/

(() => {
  const root = document.querySelector('[data-wishlist-page]');
  if (!root || !window.wishlist) return;

  const store = window.wishlist;
  const grid = root.querySelector('[data-wishlist-grid]');
  const bar = root.querySelector('[data-wishlist-bar]');
  const summary = root.querySelector('[data-wishlist-summary]');
  const empty = root.querySelector('[data-wishlist-empty]');
  const clearButton = root.querySelector('[data-wishlist-clear]');

  const message = window.wishlistBar || { show: () => {}, strings: () => ({}) };

  const templates = new Map();
  document.querySelectorAll('[data-wishlist-template]').forEach((node) => {
    templates.set(node.dataset.wishlistTemplate, node);
  });

  const clone = (name) => {
    const template = templates.get(name);
    return template ? template.content.cloneNode(true) : null;
  };

  /* ---------- karta produktu z motywu ---------- */

  const cardCache = new Map();
  const base = (root.dataset.rootUrl || '/').replace(/\/$/, '');

  const fetchCard = (handle, variantId) => {
    const url = new URL(`${base}/products/${handle}`, window.location.origin);
    url.searchParams.set('view', 'card');
    if (variantId) url.searchParams.set('variant', variantId);
    const key = url.href;
    if (!cardCache.has(key)) {
      cardCache.set(
        key,
        fetch(key)
          .then((response) => (response.ok ? response.text() : ''))
          .catch(() => '')
      );
    }
    return cardCache.get(key);
  };

  /*
    Produkt mogl zniknac ze sklepu albo zmienic uchwyt, odkad klient go polubil.
    Zamiast pustego miejsca pokazujemy wtedy zastepczy kafel - pozycja zostaje
    na liscie, zeby klient sam zdecydowal, czy ja usunac.
  */
  const fillCard = async (item, element) => {
    const slot = element.querySelector('[data-wishlist-card]');
    if (!slot) return;
    const markup = item.h ? await fetchCard(item.h, item.v) : '';

    if (markup.trim()) {
      slot.innerHTML = markup;
      /*
        Wyprzedany wzor ma nieczynny przycisk koszyka - sam z siebie nie mowi
        jednak, DLACZEGO, wiec dopisujemy podpis pod karta.
      */
      const data = slot.querySelector('[data-product-card-data]');
      if (data && data.dataset.available === 'false') {
        element.classList.add('wishlist-item--sold-out');
        const note = element.querySelector('[data-wishlist-sold-out]');
        if (note) note.hidden = false;
      }
      return;
    }

    element.classList.add('wishlist-item--gone');
    const fallback = clone('fallback');
    if (!fallback) return;
    slot.innerHTML = '';
    slot.appendChild(fallback);
    const link = slot.querySelector('[data-wishlist-fallback-link]');
    if (link && item.h) link.href = `${base}/products/${item.h}`;
  };

  /* ---------- koszyk ---------- */

  /*
    Karta niesie zwyczajny formularz produktu, ktory bez nas przeladowalby
    strone i wyrzucil klienta z listy. Przejmujemy wysylke, dokladamy wzor do
    koszyka w tle i mowimy o tym paskiem - z odnoscnikiem do koszyka, bo licznik
    w naglowku bywa juz przewiniety poza ekran.
  */
  /* O obszar dowozu pyta dzis DRUGI KROK szuflady koszyka, na drodze do kasy -
     nie brama przed dodaniem (zdjeta 21 wrzesnia 2026). */
  const addToCart = (form) => dodajDoKoszyka(form);

  const dodajDoKoszyka = async (form) => {
    const strings = message.strings();
    const submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!response.ok) throw new Error('cart');
      const cart = await fetch('/cart.js').then((res) => res.json());
      /* Licznik pokazuje karty, nie sume sztuk. Nosnik zestawu liczy sie jako
         jedna karta, a techniczne pozycje probek sa pomijane. */
      const liczbaKart = cart.items.reduce(
        (suma, item) => suma + (item.properties && item.properties._zestaw_rola === 'probka' ? 0 : 1),
        0
      );
      document.querySelectorAll('[data-cart-count]').forEach((node) => {
        node.textContent = String(liczbaKart);
      });
      message.show({
        text: strings.textCart,
        linkText: strings.linkCart,
        linkHref: strings.urlCart,
      });
    } catch {
      message.show({ text: strings.textError, error: true });
    } finally {
      if (submit) submit.disabled = false;
    }
  };

  /* ---------- rysowanie strony ---------- */

  /*
    Kafle sa TRWALE miedzy zmianami listy: trzymamy je pod identyfikatorem
    wariantu i dokladamy albo zabieramy pojedynczo. Przebudowa calej siatki przy
    kazdej zmianie kasowalaby animacje w trakcie (zniknelby caly rzad, a nie ten
    jeden kafel) i mrugala kartami, ktore juz sa na ekranie.

    Kolejnosc ustawiamy wlasciwoscia porzadku w siatce, nie przenoszeniem
    elementow w drzewie - przeniesienie wezla przerywa trwajaca animacje.
  */
  const tiles = new Map();

  const motionOff = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const buildTile = async (item, order) => {
    const fragment = clone('item');
    if (!fragment) return;
    const element = fragment.querySelector('[data-wishlist-item]');
    if (!element) return;
    element.dataset.variant = item.v;
    element.style.order = String(order);
    tiles.set(item.v, element);
    grid.appendChild(fragment);

    /*
      Kafel wchodzi dopiero z gotowa karta. Animowanie pustego pudelka, ktore
      chwile pozniej wypelnia sie trescia, wyglada jak dwa osobne skoki.
    */
    await fillCard(item, element);
    element.classList.add('wishlist-item--ready');
    if (!motionOff) element.classList.add('wishlist-item--in');
  };

  const removeTile = (variantId) => {
    const element = tiles.get(variantId);
    if (!element) return;
    tiles.delete(variantId);

    if (motionOff) {
      element.remove();
      return;
    }

    element.classList.remove('wishlist-item--in');
    element.classList.add('wishlist-item--out');
    // Zabezpieczenie na wypadek, gdyby zdarzenie konca animacji nie przyszlo.
    const drop = () => element.remove();
    element.addEventListener('animationend', drop, { once: true });
    window.setTimeout(drop, 500);
  };

  const render = () => {
    const items = store.items();

    if (empty) empty.hidden = items.length > 0;
    if (bar) bar.hidden = items.length === 0;

    if (summary) {
      // Napis podaje sekcja z tlumaczen, a znacznik [count] podmieniamy liczba.
      const pattern = root.dataset.summary || '[count]';
      summary.textContent = pattern.replace('[count]', String(items.length));
    }

    if (!grid) return;

    /*
      Siatki nie chowamy w chwili opustoszenia listy - musi zostac widoczna,
      dopoki ostatni kafel odgrywa swoje zniknienie.
    */
    if (items.length > 0) grid.hidden = false;

    const wanted = new Set(items.map((item) => item.v));
    [...tiles.keys()].forEach((variantId) => {
      if (!wanted.has(variantId)) removeTile(variantId);
    });

    items.forEach((item, index) => {
      const existing = tiles.get(item.v);
      if (existing) {
        existing.style.order = String(index);
        return;
      }
      buildTile(item, index);
    });

    if (items.length === 0) {
      window.setTimeout(() => {
        if (store.count() === 0 && tiles.size === 0) grid.hidden = true;
      }, motionOff ? 0 : 400);
    }
  };

  grid?.addEventListener('submit', (event) => {
    const form = event.target.closest('form');
    if (!form) return;
    event.preventDefault();
    addToCart(form);
  });

  /*
    Czyszczenie listy nie pyta z gory - pokazuje pasek z cofnieciem. Natywne
    okienko przegladarki jest jedynym takim miejscem w calym motywie, a cofniecie
    po fakcie jest tanszym pytaniem: nie zatrzymuje osoby, ktora wie, co robi.
  */
  clearButton?.addEventListener('click', () => {
    const snapshot = store.items();
    if (snapshot.length === 0) return;
    if (!store.clear()) return;
    const strings = message.strings();
    message.show({
      text: strings.textCleared,
      undo: () => {
        snapshot
          .slice()
          .reverse()
          .forEach((item) => store.add({ variantId: item.v, productId: item.p, handle: item.h }));
      },
    });
  });

  document.addEventListener('wishlist:change', render);
  render();
})();
